import type { ExecutionStep } from "@/lib/incidentExecution";

interface IncidentExecutionProgressProps {
  steps: ExecutionStep[];
  resultMessage: string | null;
}

export function IncidentExecutionProgress({ steps, resultMessage }: IncidentExecutionProgressProps) {
  if (steps.length === 0 && !resultMessage) return null;

  return (
    <section className="iw-section iw-execution" aria-live="polite">
      <h3 className="iw-section__title">Execution</h3>
      {steps.length > 0 ? (
        <ol className="iw-execution__steps">
          {steps.map((step) => (
            <li key={step.label} className={`iw-execution__step iw-execution__step--${step.status}`}>
              <span className="iw-execution__marker" aria-hidden="true">
                {step.status === "done" ? "✓" : step.status === "failed" ? "!" : step.status === "active" ? "…" : "○"}
              </span>
              <span>{step.label}</span>
            </li>
          ))}
        </ol>
      ) : null}
      {resultMessage ? <p className="iw-execution__result">{resultMessage}</p> : null}
    </section>
  );
}
